import { keyframes } from '@mui/system';

export const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const pulse = keyframes`
    0%, 100% {
        opacity: 0.4;
    }
    50% {
        opacity: 1;
    }
`;

export const recordingPulse = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
`;
